export default {"src":"/_next/static/media/cyberSec.0b7e8ce6.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};